import { render, staticRenderFns } from "./SettingsRolesPage.vue?vue&type=template&id=2b3251d1"
import script from "./SettingsRolesPage.vue?vue&type=script&lang=ts"
export * from "./SettingsRolesPage.vue?vue&type=script&lang=ts"
import style0 from "./SettingsRolesPage.vue?vue&type=style&index=0&id=2b3251d1&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports